import React from "react";
import CollapseContainer from './CollapseContainer';

const CollapseElement = ({ element, ...restProps }) => {
  const { id } = element;
  return (
    <CollapseContainer
      elementId={id}
      customClasses={['webiny-pb-base-page-element-style webiny-pb-layout-collapse-page formBuilder-show-collapse']}
      {...restProps}
    />
  );
};

export default React.memo(CollapseElement);
